export default __webpack_public_path__ + "static/media/IBMDocumentUnknown.2d5113d6.svg";